import _ from 'lodash';
import { dataConstants } from "services/redux/data/constants";
import ObjectClass from "utils/objects/object";
import HelperDate, { dateFormat } from 'utils/helper-date'

export default class ObjectEmployeeTransport {
	
	static get = ( objects ) => {
		return ObjectClass.get( objects, dataConstants.EMPLOYEE_TRANSPORTS );
	}
	
	static filter = ( objects ) => {
		return _.filter( objects, o => {
			return o.date === HelperDate.date().format( dateFormat.DATE )
		});
	}
	
	/**
	 * Sort teh bookings by start
	 * @param objects
	 * @returns {objects[]}
	 */
	static order = ( objects ) => {
		return _.orderBy( objects, 'created_at', 'desc' )
	}
	
	/**
	 * Remove inactive bookings and sort by start
	 * @param objects
	 * @returns {objects[]}
	 */
	static filterAndOrder = ( objects ) => {
		return this.order( this.filter( objects ) );
	}
}
